import { Injectable,NgZone } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from "@angular/router";

import { AuthService } from '../services/auth.service';

@Injectable()
export class IsLoggedIn {

  
  private promise: Promise<string>;
  filename:string ="session";

  constructor(
    private authService:AuthService,
    private zone:NgZone,private router: Router,private route: Router) {
  }

  async canActivate(route: ActivatedRouteSnapshot) {
      const currentUser = localStorage.getItem("me");
      if (!currentUser) {
          // authorised so return true
          this.router.navigate(['/auth/login']);
          return false;
      }
      // not logged in so redirect to login page with the return url
      
      return true;
  }
 
}

